export default "__VITE_ASSET__3$g10TAC__"